import React from "react";

import { convertHMToSecs } from "utils";

import Tooltip from "App/common/ui/Tooltip";
import { TOOLTIPS } from "consts";
import { ReactComponent as InformationIcon } from "assets/images/app_svg/information.svg";

function BackupPlanAdvanced(props) {
  const hours = [];
  const minutes = [];

  if (props.planSettings.cutOffTime) {
    for (let i = 0; i <= 23; i++) {
      hours.push(
        <option key={i} value={i}>
          {i > 9 ? "" + i : "0" + i}
        </option>
      );
    }
    for (let i = 0; i <= 55; i = i + 5) {
      minutes.push(
        <option key={i} value={i}>
          {i > 9 ? "" + i : "0" + i}
        </option>
      );
    }
  }

  function toggleCutOffTime(val, type) {
    let tempPlan = { ...props.planSettings };
    let time = 0;
    if (type === "hr") {
      time = convertHMToSecs(
        val,
        Math.trunc((tempPlan.cutOffTime.value % 3600) / 60)
      );
    } else {
      time = convertHMToSecs(Math.trunc(tempPlan.cutOffTime.value / 3600), val);
    }
    tempPlan.cutOffTime.value = time;
    props.setPlanSettings(tempPlan);
  }

  return (
    <div className="schedule_backup_advance">
      <div className="transparent_layer"></div>
      <div className="sub_title">
        <p>Advanced</p>
      </div>
      <div className="input_checkboxw cut_off_row just_flex  ">
        <div className="check">
          {props.planSettings.cutOffTime.isEnabled && (
            <input
              type="checkbox"
              className="input_checkbox"
              id="schedule_backup_122"
              checked
              onClick={() =>
                props.setPlanSettings({
                  ...props.planSettings,
                  cutOffTime: {
                    ...props.planSettings.cutOffTime,
                    isEnabled: !props.planSettings.cutOffTime.isEnabled
                  }
                })
              }
            />
          )}
          {!props.planSettings.cutOffTime.isEnabled && (
            <input
              type="checkbox"
              className="input_checkbox"
              id="schedule_backup_122"
              onClick={() =>
                props.setPlanSettings({
                  ...props.planSettings,
                  cutOffTime: {
                    ...props.planSettings.cutOffTime,
                    isEnabled: !props.planSettings.cutOffTime.isEnabled
                  }
                })
              }
            />
          )}
          <label htmlFor="schedule_backup_122"></label>
        </div>
        <div className="cow_box ">
          <div className="cutt-off_wrap flex_align">
            <p
              className="checkbox_p"
              onClick={() =>
                props.setPlanSettings({
                  ...props.planSettings,
                  cutOffTime: {
                    ...props.planSettings.cutOffTime,
                    isEnabled: !props.planSettings.cutOffTime.isEnabled
                  }
                })
              }
            >
              Cut-off Time:{" "}
            </p>
            <div className="hours_mins_wrap flex_align">
              <div
                className="hours_wrap flex_align transparent_layer_wrap"
                style={{ marginRight: "10px" }}
              >
                {!props.planSettings.cutOffTime.isEnabled && (
                  <div className="transparent_layer"></div>
                )}
                <div className="hh_mm_div">HH</div>
                <div className="main_select">
                  <select
                    onChange={e => toggleCutOffTime(e.target.value, "hr")}
                    value={Math.trunc(
                      props.planSettings.cutOffTime.value / 3600
                    )}
                  >
                    {hours}
                  </select>
                </div>
              </div>
              <div className="mins_wrap flex_align transparent_layer_wrap">
                {!props.planSettings.cutOffTime.isEnabled && (
                  <div className="transparent_layer"></div>
                )}
                <div className="hh_mm_div">MM</div>
                <div className="main_select">
                  <select
                    onChange={e => toggleCutOffTime(e.target.value, "mn")}
                    value={Math.trunc(
                      (props.planSettings.cutOffTime.value % 3600) / 60
                    )}
                  >
                    {minutes}
                  </select>
                </div>
              </div>
              <Tooltip {...TOOLTIPS.backupSettings.schedule.cutOff}>
                <span className="icon">
                  <InformationIcon />
                </span>
              </Tooltip>
            </div>
          </div>
        </div>
      </div>
      <div className="input_checkboxw just_flex">
        <div className="check">
          {props.planSettings.scheduleInfo.advanced.preventSleep && (
            <input
              type="checkbox"
              className="input_checkbox"
              id="schedule_backup_21"
              checked
              onClick={() =>
                props.setPlanSettings({
                  ...props.planSettings,
                  scheduleInfo: {
                    ...props.planSettings.scheduleInfo,
                    advanced: {
                      ...props.planSettings.scheduleInfo.advanced,
                      preventSleep: !props.planSettings.scheduleInfo.advanced
                        .preventSleep
                    }
                  }
                })
              }
            />
          )}
          {!props.planSettings.scheduleInfo.advanced.preventSleep && (
            <input
              type="checkbox"
              className="input_checkbox"
              id="schedule_backup_21"
              onClick={() =>
                props.setPlanSettings({
                  ...props.planSettings,
                  scheduleInfo: {
                    ...props.planSettings.scheduleInfo,
                    advanced: {
                      ...props.planSettings.scheduleInfo.advanced,
                      preventSleep: !props.planSettings.scheduleInfo.advanced
                        .preventSleep
                    }
                  }
                })
              }
            />
          )}
          <label for="schedule_backup_21"></label>
        </div>
        <p
          className="checkbox_p"
          onClick={() =>
            props.setPlanSettings({
              ...props.planSettings,
              scheduleInfo: {
                ...props.planSettings.scheduleInfo,
                advanced: {
                  ...props.planSettings.scheduleInfo.advanced,
                  preventSleep: !props.planSettings.scheduleInfo.advanced
                    .preventSleep
                }
              }
            })
          }
        >
          Prevent the computer from going to Hibernate / Sleep mode
        </p>
      </div>
      <div className="input_checkboxw just_flex">
        <div className="check">
          {props.planSettings.scheduleInfo.advanced.runMissed && (
            <input
              type="checkbox"
              className="input_checkbox"
              id="schedule_backup_22"
              checked
              onClick={() =>
                props.setPlanSettings({
                  ...props.planSettings,
                  scheduleInfo: {
                    ...props.planSettings.scheduleInfo,
                    advanced: {
                      ...props.planSettings.scheduleInfo.advanced,
                      runMissed: !props.planSettings.scheduleInfo.advanced
                        .runMissed
                    }
                  }
                })
              }
            />
          )}
          {!props.planSettings.scheduleInfo.advanced.runMissed && (
            <input
              type="checkbox"
              className="input_checkbox"
              id="schedule_backup_22"
              onClick={() =>
                props.setPlanSettings({
                  ...props.planSettings,
                  scheduleInfo: {
                    ...props.planSettings.scheduleInfo,
                    advanced: {
                      ...props.planSettings.scheduleInfo.advanced,
                      runMissed: !props.planSettings.scheduleInfo.advanced
                        .runMissed
                    }
                  }
                })
              }
            />
          )}
          <label htmlFor="schedule_backup_22"></label>
        </div>
        <p
          className="checkbox_p"
          onClick={() =>
            props.setPlanSettings({
              ...props.planSettings,
              scheduleInfo: {
                ...props.planSettings.scheduleInfo,
                advanced: {
                  ...props.planSettings.scheduleInfo.advanced,
                  runMissed: !props.planSettings.scheduleInfo.advanced.runMissed
                }
              }
            })
          }
        >
          Run missed backup at system startup, if the computer is switched off
          at the scheduled time
        </p>
      </div>
      <div className="input_checkboxw just_flex">
        <div className="check">
          {props.planSettings.scheduleInfo.advanced.onWakeup.checked && (
            <input
              type="checkbox"
              className="input_checkbox"
              id="schedule_backup_23"
              onClick={() =>
                props.setPlanSettings({
                  ...props.planSettings,
                  scheduleInfo: {
                    ...props.planSettings.scheduleInfo,
                    advanced: {
                      ...props.planSettings.scheduleInfo.advanced,
                      onWakeup: {
                        ...props.planSettings.scheduleInfo.advanced.onWakeup,
                        checked: !props.planSettings.scheduleInfo.advanced
                          .onWakeup.checked
                      }
                    }
                  }
                })
              }
              checked
            />
          )}
          {!props.planSettings.scheduleInfo.advanced.onWakeup.checked && (
            <input
              type="checkbox"
              className="input_checkbox"
              id="schedule_backup_23"
              onClick={() =>
                props.setPlanSettings({
                  ...props.planSettings,
                  scheduleInfo: {
                    ...props.planSettings.scheduleInfo,
                    advanced: {
                      ...props.planSettings.scheduleInfo.advanced,
                      onWakeup: {
                        ...props.planSettings.scheduleInfo.advanced.onWakeup,
                        checked: !props.planSettings.scheduleInfo.advanced
                          .onWakeup.checked
                      }
                    }
                  }
                })
              }
            />
          )}
          <label for="schedule_backup_23"></label>
        </div>
        <p
          className="checkbox_p"
          onClick={() =>
            props.setPlanSettings({
              ...props.planSettings,
              scheduleInfo: {
                ...props.planSettings.scheduleInfo,
                advanced: {
                  ...props.planSettings.scheduleInfo.advanced,
                  onWakeup: {
                    ...props.planSettings.scheduleInfo.advanced.onWakeup,
                    checked: !props.planSettings.scheduleInfo.advanced.onWakeup
                      .checked
                  }
                }
              }
            })
          }
        >
          Wake up the computer from Hibernate / Sleep mode for backup
        </p>
      </div>
    </div>
  );
}

export default BackupPlanAdvanced;
